import { Pipe, PipeTransform } from '@angular/core';
import { LoaderStore } from '@macs-frontend/core/store/loader.store';
import { runInAction } from 'mobx';

@Pipe({ name: 'isLoading', pure: false })
export class IsLoadingPipe implements PipeTransform {
  constructor(private loaderStore: LoaderStore) {}

  public transform(value: string | string[]): boolean {
    return runInAction(() =>
      (typeof value === 'string' ? [value] : value).some(value =>
        this.loaderStore.loaders.includes(value),
      ),
    );
  }
}
